import React from "react";
import { FaGithub } from "react-icons/fa";
import { CgFileDocument } from "react-icons/cg";
import { CiImageOn } from "react-icons/ci";

const ProjectBox = ({
  projectPhoto,
  projectName,
  description,
  githubLink,
  devpost,
  techStack,
}) => {
  const showGithub = !!githubLink;
  const showDemo = !!devpost;
  const hasImage = !!projectPhoto;

  return (
    <div className="projectBox">
      {hasImage ? (
        <img
          className="projectPhoto"
          src={projectPhoto}
          alt={`${projectName || "Project"} screenshot`}
        />
      ) : (
        <div className="projectPhotoPlaceholder" aria-label="No screenshot available">
          <CiImageOn size={28} />
        </div>
      )}

      <div>
        <br />
        {projectName && <h3>{projectName}</h3>}
        {projectName && <br />}

        <p>{description}</p>

        {techStack && (
          <>
            <br />
            <span className="projectTech">
              <b>Tech:</b> {techStack}
            </span>
          </>
        )}

        <br />

        {showGithub && (
          <a href={githubLink} target="_blank" rel="noreferrer">
            <button className="projectbtn">
              <FaGithub /> Github
            </button>
          </a>
        )}

        {showDemo && (
          <a href={devpost} target="_blank" rel="noreferrer">
            <button className="projectbtn">
              <CgFileDocument /> Devpost
            </button>
          </a>
        )}
      </div>
    </div>
  );
};

export default ProjectBox;